import { WindowPanel } from './windowPanel';

export const WINDOWS: WindowPanel[] = [];
